import Vue from 'vue';
import { initialState } from './state';

export default {
  setActiveObject(state, obj) {
    state.activeObject =
      state.activeObject &&
      ((obj.playerId && state.activeObject.playerId === obj.playerId) ||
        state.activeObject.order === obj.order ||
        state.activeObject.id === obj.id)
        ? null
        : obj;

    if (state.drawingMode) {
      state.drawingMode = false;
    }
    if (state.wavy) {
      state.wavy = false;
    }
  },

  removeActiveObject(state) {
    state.activeObject = null;
  },

  setCanvasColor(state, color) {
    state.color = color;
  },

  toggleDrawingMode(state) {
    state.drawingMode = !state.drawingMode;
    state.wavy = false;
    state.dashed = false;
  },

  removeDrawingMode(state) {
    state.drawingMode = false;
  },

  setLineWidth(state, width) {
    if (width < 1) {
      state.lineWidth = 1;
    } else if (width > 150) {
      state.lineWidth = 150;
    } else {
      state.lineWidth = width;
    }
  },

  setBackgrounds(state, backgrounds) {
    state.backgrounds = backgrounds;
  },

  setObjects(state, objects) {
    state.objects = objects;
  },

  reset(state) {
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },

  export(state, json) {
    if (!state.moduleKey) return;

    state.export = json;
  },

  exportImage(state, image) {
    state.image = image;
  },

  setPlayers(state, players) {
    state.players = players;
  },

  setUsedPlayerIds(state, playerIds) {
    if (state.kickIndex !== null && state.kickUsedPlayerIds[state.kickIndex]) {
      Vue.set(state.kickUsedPlayerIds, state.kickIndex, playerIds);
      return;
    }

    if (!state.usedPlayerKey || !state[state.usedPlayerKey]) {
      return;
    }

    Vue.set(state, state.usedPlayerKey, playerIds);
  },

  addUsedPlayerId(state, playerId) {
    if (state.kickIndex !== null && state.kickUsedPlayerIds[state.kickIndex]) {
      state.kickUsedPlayerIds[state.kickIndex].push(playerId);
      return;
    }

    if (
      !state.usedPlayerKey ||
      !state[state.usedPlayerKey] ||
      state[state.usedPlayerKey].includes(playerId)
    ) {
      return;
    }

    state[state.usedPlayerKey].push(playerId);
  },

  removeUsedPlayerId(state, playerId) {
    if (state.kickIndex !== null && state.kickUsedPlayerIds[state.kickIndex]) {
      const index = state.kickUsedPlayerIds[state.kickIndex].indexOf(playerId);
      state.kickUsedPlayerIds[state.kickIndex].splice(index, 1);
      return;
    }

    if (!state.usedPlayerKey || !state[state.usedPlayerKey]) {
      return;
    }

    const index = state[state.usedPlayerKey].indexOf(playerId);

    if (index === -1) return;

    state[state.usedPlayerKey].splice(index, 1);
  },

  setKickIndex(state, index) {
    state.kickIndex = index;
    if (!state.kickUsedPlayerIds[state.kickIndex]) {
      state.kickUsedPlayerIds[state.kickIndex] = [];
    }
  },

  setUsedPlayerKey(state, key) {
    state.usedPlayerKey = key;
  },

  setModuleKey(state, key) {
    state.moduleKey = key;
  },

  toggleWavy(state) {
    state.wavy = !state.wavy;
    state.drawingMode = false;
  },

  removeWavy(state) {
    state.wavy = false;
    state.dashed = false;
  },

  setDashed(state, value) {
    state.dashed = value;
  },

  setOpacity(state, value) {
    state.opacity = value;
  },
};



// WEBPACK FOOTER //
// ./src/store/matches-editor/mutations.js